import moment from "moment";
import { combineReducers, Reducer } from "redux";

import { isServer } from "../../core/detection";
import * as CookieHelper from "../../shared/helpers/cookieHelper";
import * as R from "../../shared/state/reducers";
import { Actions } from "./actions";

/**
 * Browser only - set a cookie whenever we change the currency.
 */
const saveCurrencyState = (state, currency: IBaseCurrency) => {
  if (isServer()) {
    return; // No cookies on the server
  }

  CookieHelper.setCookie(CookieHelper.keys.currencyPref, currency.code, moment().utc().add(1, "y"));
};

/**
 * #576 To access the currency preference in components involved in the server render
 * we first load the value of the cookie (the code - e.g. "GBP") into the redux store (see server.ts).
 * This reducer looks at the currency code and refreshes/initialises the currency key whenever we refresh all currencies.
 */
const refreshCurrency = (state: IState<IBaseCurrency>, action: IStoreAction<IFetchApiResponse<IBaseCurrency[]>>) => {
  if (!state
    || !state.data
    || !state.data.code
    || !R.isMatch(action.type, Actions.LoadAllCurrencies)
    || !R.isPayloadAction(action)
    || R.getPayloadActionStatus(action) !== "OK"
  ) {
    // We'll let another reducer handle initialisation of this property if it's needed
    return state;
  }

  const matchingCurrencies = action.payload.json.filter(currency => currency.code === state.data.code);

  if (matchingCurrencies.length < 1) {
    console.error(`Currency ${state.data.code} was requested, but this currency is not available. Ignoring`);
    return state;
  }

  const updatedCurrency = matchingCurrencies[0];

  return new R.State(updatedCurrency, "OK");
};

const CurrencyReducer: Reducer<IState<IBaseCurrency>> = R.chain(
  R.fromPayload<IBaseCurrency, IBaseCurrency>(Actions.ChangeCurrency, x => x, saveCurrencyState),
  refreshCurrency,
);

export default CurrencyReducer;
